import '../index.scss';
import '../CategorySelect/index.scss';
import PropTypes from "prop-types";

const ReadyToStart = (props) => {
  if (!props.categories || props.categories.length > 0) {
    return (
      <div className="EM-RTS-overlayScreen" role="dialog" aria-modal="true">
        <div className="EMRTS-box EM-RTS-popupWindow">
          <div className="EMRTS-contentcontainer">{props.children}</div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="EM-RTS-overlayScreen" role="dialog" aria-modal="true" aria-label="No categories selected">
        <div className="EMRTS-box EM-RTS-popupWindow">
          <div
            className="EMRTS-contentcontainer"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "70%",
            }}
          >
            <div>
              <div className="EM-CS-RTS-titletext">
                There are no selected categories.
              </div>
              <div className="EM-CS-RTS-titletext">
                Please select at least one category.
              </div>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <div
                className="EM-CS-button-selectcats"
                onClick={props.resetCategories}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); props.resetCategories(); } }}
                role="button" tabIndex={0} aria-label="Select categories"
              >
                Select Categories
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
export default ReadyToStart;
ReadyToStart.propTypes = {
  categories: PropTypes.array,
  resetCategories: PropTypes.func,
  children: PropTypes.element,
};
